import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {ArchivingProfileStoreClass} from './ArchivingProfileStore';
import StagingArchivingProfileActions from 'actions/StagingArchivingProfileActions';

@immutableStore
class StagingArchivingProfileStore extends ArchivingProfileStoreClass {
  constructor() {
    super(...arguments);
    this.bindActions(StagingArchivingProfileActions);
  }
  // Override the default.  This is hacky.  Should fix
  saveSuccess() {
    this.setState({
      isSaving: false,
    });
  }
  saveError() {
    this.setState({
      isSaving: false,
    });
  }
}

export default alt.createStore(StagingArchivingProfileStore, 'StagingArchivingProfileStore');
